export default '2.1.0';



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mhead-js/dist/_version.js
// module id = 97
// module chunks = 0